// Per-device notification preferences for the bell drawers ("Preferences"
// panel). Scoped so the /app user's choices and the admin's never collide.
// A missing key means "on"; the drawers treat `false` as switched off.
const keyFor = (scope) => `ms:notifPrefs:${scope}`;

export function getNotifPrefs(scope) {
  try { return JSON.parse(localStorage.getItem(keyFor(scope)) || "{}") || {}; }
  catch { return {}; }
}

export function setNotifPref(scope, key, value) {
  const next = { ...getNotifPrefs(scope), [key]: !!value };
  try { localStorage.setItem(keyFor(scope), JSON.stringify(next)); } catch { /* quota */ }
  return next;
}

export const prefOn = (prefs, key) => prefs?.[key] !== false;
